import { Map, List, fromJS } from 'immutable'
import Api from '../api'
import { push, replace } from 'react-router-redux'
const apiRoot = '/datatable'
import QueryString from 'query-string'
import { isLoading, formMessages } from '../form/actions'

function removeActionFromLocation(location = {}, refetchData = false) {
  let { search } = location
  let state = QueryString.parse(search)
  delete state.action
  delete state.editId
  if (refetchData) state.refetch = new Date().getTime()

  location.search = QueryString.stringify(state)
  return location
}

/**
 * Crud fetch items
 */

export function dataTableItemsFetch(table_id, config = {}, apiPath = apiRoot) {
  return (dispatch, getState) => {
    // if(getState().dataTable.getIn([table_id, 'fetchLoading']))
    //   return console.log('Prevent fetch because fetchLoading', table_id)

    dispatch(dataTableItemsFetchLoading(table_id, true))

    Api.get(apiPath, config)
      .then(({ data = {} }) => {
        if (data.success) {
          dispatch(dataTableItemsFetchSuccess(table_id, data.items, data.meta))
        } else {
          dispatch(dataTableItemsFetchError(table_id, data.message))
        }
      })
      .catch(err => {
        dispatch(dataTableItemsFetchError(table_id, err.message))
      })
      .finally(() => {
        dispatch(dataTableItemsFetchLoading(table_id, false))
      })
  }
}

export function dataTableItemsFetchLoading(table_id, loading = true) {
  return {
    type: 'DATATABLE_ITEMS_FETCH_LOADING',
    table_id,
    loading,
  }
}

export function dataTableItemsFetchError(table_id, message = '') {
  return {
    type: 'DATATABLE_ITEMS_FETCH_ERROR',
    table_id,
    message,
  }
}

export function dataTableItemsFetchSuccess(table_id, items = List(), meta = Map()) {
  return {
    type: 'DATATABLE_ITEMS_FETCH_SUCCESS',
    table_id,
    items,
    meta,
  }
}

/**
 * Crud fetch items
 */

export function dataTableConfigFetch(table_id, config = {}, apiPath = apiRoot) {
  return dispatch => {
    dispatch(dataTableConfigFetchLoading(table_id, true))

    Api.get(`${apiPath}/config`, config)
      .then(({ data = {} }) => {
        if (data.success) {
          dispatch(dataTableConfigFetchSuccess(table_id, data))
        } else {
          dispatch(dataTableConfigFetchError(table_id, data.message))
        }
      })
      .catch(err => {
        dispatch(dataTableConfigFetchError(table_id, err.message))
      })
      .finally(() => {
        dispatch(dataTableConfigFetchLoading(table_id, false))
      })
  }
}

export function dataTableConfigFetchLoading(table_id, loading = true) {
  return {
    type: 'DATATABLE_CONFIG_FETCH_LOADING',
    table_id,
    loading,
  }
}

export function dataTableConfigFetchError(table_id, message = '') {
  return {
    type: 'DATATABLE_CONFIG_FETCH_ERROR',
    table_id,
    message,
  }
}

export function dataTableConfigFetchSuccess(table_id, data) {
  return {
    type: 'DATATABLE_CONFIG_FETCH_SUCCESS',
    table_id,
    data,
  }
}

/**
 * Crud create item
 */

export function dataTableItemCreate(table_id, entity, item, formId) {
  return (dispatch, getState) => {
    dispatch(dataTableItemCreateLoading(table_id, true))

    let { location } = getState().routing

    if (Map.isMap(item)) item = item.toJS()

    Api.post(apiRoot, { item }, { entity })
      .then(({ data = {} }) => {
        if (data.success) {
          dispatch(dataTableItemCreateSuccess(table_id, data.item))
          dispatch(push(removeActionFromLocation(location, true)))
        } else {
          dispatch(dataTableItemCreateError(table_id, data.message))
          dispatch({
            type: 'FORM_SUBMIT_VALIDATION_ERROR',
            formId,
            errors: fromJS(data.errors || {}),
            messages: fromJS(data.messages || []),
          })
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(dataTableItemCreateError(table_id, err.message))
      })
      .finally(() => {
        dispatch(dataTableItemCreateLoading(table_id, false))
      })
  }
}

export function dataTableItemCreateLoading(table_id, loading = true) {
  return {
    type: 'DATATABLE_ITEM_CREATE_LOADING',
    table_id,
    loading,
  }
}

export function dataTableItemCreateError(table_id, message = '') {
  return {
    type: 'DATATABLE_ITEM_CREATE_ERROR',
    table_id,
    message,
  }
}

export function dataTableItemCreateSuccess(table_id, item = Map()) {
  return {
    type: 'DATATABLE_ITEM_CREATE_SUCCESS',
    table_id,
    item,
  }
}

/**
 * Crud update item
 */

export function dataTableItemUpdate(table_id, entity, item_id, item, formId) {
  return (dispatch, getState) => {
    dispatch(dataTableItemUpdateLoading(table_id, item_id, false))
    if (Map.isMap(item)) item = item.toJS()

    let { location } = getState().routing

    Api.patch(`${apiRoot}`, { item }, { entity, item_id })
      .then(({ data = {} }) => {
        if (data.success) {
          dispatch(dataTableItemUpdateSuccess(table_id, item_id, data.item))
          dispatch(push(removeActionFromLocation(location, true)))
          dispatch(isLoading(formId, false))
        } else {
          dispatch(dataTableItemUpdateError(table_id, item_id, data.message))
          dispatch({
            type: 'FORM_SUBMIT_VALIDATION_ERROR',
            formId,
            errors: fromJS(data.errors || {}),
            messages: fromJS(data.messages || []),
          })
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(dataTableItemUpdateError(table_id, item_id, err.message))
      })
      .finally(() => {
        dispatch(dataTableItemUpdateLoading(table_id, false))
      })
  }
}

export function dataTableItemUpdateLoading(table_id, item_id, loading = true) {
  return {
    type: 'DATATABLE_ITEM_UPDATE_LOADING',
    table_id,
    item_id,
    loading,
  }
}

export function dataTableItemUpdateError(table_id, item_id, message = '') {
  return {
    type: 'DATATABLE_ITEM_UPDATE_ERROR',
    table_id,
    item_id,
    message,
  }
}

export function dataTableItemUpdateSuccess(table_id, item_id, item = Map()) {
  return {
    type: 'DATATABLE_ITEM_UPDATE_SUCCESS',
    table_id,
    item_id,
    item,
  }
}

/**
 * Crud delete item
 */

export function dataTableItemDelete(table_id, entity, item_id, form_id) {
  return (dispatch, getState) => {
    dispatch(dataTableItemDeleteLoading(table_id, item_id, true))

    let { location } = getState().routing

    Api.delete(`${apiRoot}`, { delete: true }, { entity, item_id })
      .then(({ data = {} }) => {
        if (data.success) {
          dispatch(dataTableItemDeleteSuccess(table_id, item_id))
          dispatch(push(removeActionFromLocation(location, true)))
          dispatch(isLoading(form_id, false))
        } else {
          dispatch(dataTableItemDeleteError(table_id, item_id, data.messages))
          dispatch(formMessages(form_id, data.messages))
          dispatch(isLoading(form_id, false))
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(dataTableItemDeleteError(table_id, item_id, err.messages))
        dispatch(formMessages(form_id, err.messages || [err.message]))
        dispatch(isLoading(form_id, false))
      })
      .finally(() => {
        dispatch(dataTableItemDeleteLoading(table_id, false))
        dispatch(isLoading(form_id, false))
      })
  }
}

export function dataTableItemDeleteLoading(table_id, item_id, loading = true) {
  return {
    type: 'DATATABLE_ITEM_DELETE_LOADING',
    table_id,
    item_id,
    loading,
  }
}

export function dataTableItemDeleteError(table_id, item_id, message = '') {
  return {
    type: 'DATATABLE_ITEM_DELETE_ERROR',
    table_id,
    item_id,
    message,
  }
}

export function dataTableItemDeleteSuccess(table_id, item_id) {
  return {
    type: 'DATATABLE_ITEM_DELETE_SUCCESS',
    table_id,
    item_id,
  }
}
